export var SectionSizes;
(function (SectionSizes) {
    SectionSizes["section_1"] = "section_1";
    SectionSizes["section_2"] = "section_2";
})(SectionSizes || (SectionSizes = {}));
//# sourceMappingURL=constants.js.map